/// <reference path="../include.ts" />

namespace project_guide {

	import RootScene = scn.core.RootScene;
	import SceneManager = scn.SceneManager;
	import IUrnDescribable = project_common.IUrnDescribable;
	import Region = project_common.Region;
	import Area = project_common.Area;
	import Zone = project_common.Zone;
	import Species = project_common.Species;
	import Dom = alm.util.Dom;
	import Application = project_common.Application;
	import CurrentState = project_common.CurrentState;

	export class IndexScene extends RootScene {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(sceneManager:SceneManager) {
			super(sceneManager);

			this.drawerContent = DrawerContent.getInstance();
			this.drawerContent.ready();

			this.header = Header.getInstance();
			this.header.ready();

			this.introduction = Introduction.getInstance();
			this.introduction.ready();

			this.listView = ListView.getInstance();
			this.listView.ready();

			this.cardView = CardView.getInstance();
			this.cardView.ready();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implOnLoad():cmd.Command {
			return new cmd.Func(():void => {
				trace('[IndexScene ' + this.getName() + '] load');

				const presetContext = Application.getPresetContext();

				const message = <SceneTransferMessage>this.getTransferInfo().message;
				this.currentState = message.currentState;

				// drawer
				{
					this.drawerContent.setContext();
					this.drawerContent.addEventListener(DrawerContentEvent.requireGotoScene, this.drawerContentRequireGotoSceneHandler);
					this.drawerContent.show();
				}

				// header
				{
					this.header.setContext();
					this.header.show();
				}

				// introduction
				{
					this.introduction.setContext();
					this.introduction.show();
				}

				// list view
				{
					this.listView.setContext();
					this.listView.addEventListener(ListViewEvent.requireGotoScene, this.listViewRequireGotoSceneHandler);
					this.listView.show();
				}
			});
		}

		protected implOnUnload():cmd.Command {
			return new cmd.Func(():void => {
				trace('[IndexScene ' + this.getName() + '] unload');

				this.currentState = null;

				// drawer
				{
					this.drawerContent.removeEventListener(DrawerContentEvent.requireGotoScene, this.drawerContentRequireGotoSceneHandler);
					this.drawerContent.clearContext();
					this.drawerContent.hide();
				}

				// header
				{
					this.header.clearContext();
					this.header.hide();
				}

				// introduction
				{
					this.introduction.clearContext();
					this.introduction.hide();
				}

				// list view
				{
					this.listView.removeEventListener(ListViewEvent.requireGotoScene, this.listViewRequireGotoSceneHandler);
					this.listView.clearContext();
					this.listView.hide();
				}
			});
		}

		protected implOnArrive():cmd.Command {
			return new cmd.Func(():void => {
				trace('[IndexScene ' + this.getName() + '] arrive');

				const message = <SceneTransferMessage>this.getTransferInfo().message;

				// set scroll
				if (message.scroll) {
					Dom.scrollTo(0, message.smoothScroll);
				}
			});
		}

		protected implOnLeave():cmd.Command {
			return new cmd.Func(():void => {
				trace('[IndexScene ' + this.getName() + '] leave');
			});
		}

		protected implOnAscend():cmd.Command {
			return new cmd.Func(():void => {
				trace('[IndexScene ' + this.getName() + '] ascend');
			});
		}

		protected implOnDescend():cmd.Command {
			return new cmd.Func(():void => {
				trace('[IndexScene ' + this.getName() + '] descend');
			});
		}





		private listViewRequireGotoSceneHandler = (event:ListViewEvent):void => {
			this.gotoSceneByDescriptor(event.region, event.area, event.zone, event.species, true, false);
		};

		private drawerContentRequireGotoSceneHandler = (event:DrawerContentEvent):void => {
			//this.gotoSceneByDescriptor(event.region, event.area, null, null, true, true);

			// scrolling to area anchor, even if departure and destination path same
			this.gotoSceneByDescriptor(event.region, event.area, null, null, false, false);
			this.listView.scrollToArea(event.area, true);
		};

		private gotoSceneByDescriptor(region:Region, area:Area, zone:Zone, species:Species, scroll:boolean, smoothScroll:boolean):void {
			const descriptors:IUrnDescribable[] = [region, area, zone, species];
			const n = descriptors.length;
			const urns:string[] = [];
			for (let i = 0; i < n; ++i) {
				const descriptor = descriptors[i];
				if (descriptor) {
					urns.push(descriptor.urn);
				} else {
					break;
				}
			}
			const path = '/' + urns.join('/');
			this.gotoScene(path, new SceneTransferMessage(this.currentState, scroll, smoothScroll));
		}





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		private currentState:CurrentState;

		private drawerContent:DrawerContent;
		private header:Header;
		private introduction:Introduction;
		private listView:ListView;
		private cardView:CardView;
	}
}
